var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseApi } from '../baseApi';
export default class SkusApi extends BaseApi {
    constructor() {
        super(...arguments);
        this.apiBasePath = 'skus';
    }
    getSKUs(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'GET',
                route: `${this.apiBasePath}`,
                params: params,
            });
        });
    }
    getSKUsV2(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'GET',
                route: `v2/${this.apiBasePath}`,
                params: params,
            });
        });
    }
    createSKU(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'POST',
                route: `${this.apiBasePath}`,
                data,
            });
        });
    }
    bulkCreateSKUs(skus) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'POST',
                route: `${this.apiBasePath}/bulk`,
                data: { skus },
            });
        });
    }
    importSKUs(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'POST',
                route: `${this.apiBasePath}/import`,
                data,
            });
        });
    }
    previewSKUsImport(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'POST',
                route: `${this.apiBasePath}/import-preview`,
                data,
            });
        });
    }
    updateSKU(id, data) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'PUT',
                route: `${this.apiBasePath}`,
                params: {
                    id: id,
                },
                data,
            });
        });
    }
    deleteSKU(id_1) {
        return __awaiter(this, arguments, void 0, function* (id, softDelete = true) {
            return yield this.apiCall({
                method: 'DELETE',
                route: `${this.apiBasePath}`,
                params: {
                    id: id,
                    softDelete: softDelete,
                },
            });
        });
    }
    searchSKUs(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'GET',
                route: `v2/${this.apiBasePath}/widget-search`,
                params: params,
            });
        });
    }
    batchUpdateStatus(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'POST',
                route: `${this.apiBasePath}/batch-status`,
                data,
            });
        });
    }
}
//# sourceMappingURL=index.js.map